import * as categoryAPI from "./category"
import * as constraintAPI from "./constraint"
import * as constraintTypeAPI from "./constraintType"

export const filterConstraintTypesByCategory = (constraintTypes, category) =>
  constraintTypes.filter(
    constraintType =>
      constraintTypeAPI.getCategory(constraintType) ===
      categoryAPI.getId(category),
  )

export const findConstraintTypeForConstraint = (constraintTypes, constraint) =>
  constraintTypes.find(
    constraintType =>
      constraintTypeAPI.getId(constraintType) ===
      constraintAPI.getType(constraint),
  )

export const filterConstraintsByCategory = (
  constraints,
  constraintTypes,
  category,
) =>
  constraints.filter(constraint => {
    const constraintType = findConstraintTypeForConstraint(
      constraintTypes,
      constraint,
    )

    return (
      Boolean(constraintType) &&
      constraintTypeAPI.getCategory(constraintType) ===
        categoryAPI.getId(category)
    )
  })

export const filterConstraintsByType = (constraints, constraintType) =>
  constraints.filter(
    constraint =>
      constraintAPI.getType(constraint) ===
      constraintTypeAPI.getId(constraintType),
  )

// As there aren't many constraint categories, they are just hardcoded
export const categories = [
  { id: `EVENT`, name: `По событиям` },
  { id: `RESOURCE`, name: `По ресурсу` },
  // TODO recommit in brightness future! or never
  // { id: `PLAN`, name: `По плану` },
]

export const argumentTypes = {
  INT: `INTEGER`,
  LONG: `LONG`,
  SELECT: `SELECT`,
  TIMESTAMP: `TIMESTAMP`,
  RESOURCE_TYPE: `RESOURCE_TYPE`,
  EVENT_TYPE: `EVENT_TYPE`,
  PLAN: `PLAN`,
  PLAN_TYPE: `PLAN_TYPE`,
}

export const violationLevels = {
  WARNING: `WARN`,
  ERROR: `ERROR`,
}

export { default as categoryAPI } from "./category"
export { default as constraintAPI } from "./constraint"
export { default as constraintTypeAPI } from "./constraintType"
